const common = {
  // Navbar
  nav_glasses: 'Smart Glasses',
  nav_brand: 'Our Story',
  nav_dealer: 'Partnership',
  nav_store: 'Stores',
  nav_buy: 'Buy Now',
  nav_coming_soon: 'Coming Soon',

  // Video
  video_title: 'See the Next You',
  video_subtitle: '2 minutes to understand how NIMO reshapes your focus',
  video_play_label: 'Click to watch the brand film',

  // Hero
  hero_label: 'NIMO · Smart Glasses',
  hero_line1: 'Mind at Rest',
  hero_line2: 'Flow Begins',
  hero_desc: 'NIMO Smart Glasses filter digital noise so you can focus on what matters.',
  hero_cta: 'Buy Now',

  // Brand
  brand_label: 'Brand Story',
  brand_title: 'Our Story',
  brand_italic: 'Reclaim Your Focus',
  brand_h3_1: 'Not more features,',
  brand_h3_2: 'but fewer distractions',
  brand_p1: 'NIMO believes true intelligence is not about piling on features — it\'s about knowing when to appear and when to step back. We fuse cutting-edge AI with ultra-lightweight industrial design to create smart glasses that are both a tech tool and an all-day wearable.',
  brand_p2: 'Behind every pair of NIMO smart glasses lies a simple yet profound belief: help you filter the noise of the digital world so your attention belongs to you again.',
  brand_cta: 'Explore NIMO',
  brand_quote: '\u201c Focus is the rarest luxury of our time \u201d',
  brand_v1_title: 'Display Only',
  brand_v1_desc: 'Our proprietary engine processes and filters digital noise in real time, keeping only what truly needs your attention — so you stay elegant and effective.',
  brand_v2_title: 'Privacy-First Design',
  brand_v2_desc: 'Zero cameras, encrypted data protection. Use NIMO anywhere without privacy concerns or social awkwardness.',
  brand_v3_title: 'Ultra-Light Comfort',
  brand_v3_desc: 'Titanium + carbon fiber frame, just 29 g — virtually indistinguishable from regular glasses. Wear all day without pressure.',

  // ValuePillars
  vp_label: 'Core Values',
  vp_title: 'Redefining the Role of Glasses in Your Life',
  vp_p1_cat: 'FOCUS',
  vp_p1_title: 'HUD Display — Only What Matters',
  vp_p1_body: 'Every day your brain processes 11 hours of digital information — emails, messages, notifications, pop-ups. NIMO filters the noise and surfaces only what truly deserves your attention. This isn\'t "use your phone less" — it\'s redefining what\'s worth your focus.',
  vp_p1_highlight: 'Redefine what deserves your attention.',
  vp_p1_stat: '1500 nits',
  vp_p1_stat_label: 'Binocular Waveguide',
  vp_p2_cat: 'PRIVACY',
  vp_p2_title: 'Zero Cameras — Welcome Everywhere',
  vp_p2_body: 'We don\'t record your world — we illuminate your path. NIMO\'s camera-free design is a strategic privacy-first choice, not a technical compromise. Bedroom, boardroom, gym, locker room — use it freely in any setting.',
  vp_p2_highlight: 'Your privacy, fully in your control.',
  vp_p2_stat: '0',
  vp_p2_stat_label: 'Cameras',
  vp_p3_cat: 'COMFORT',
  vp_p3_title: '29 g — Light as Nothing',
  vp_p3_body: 'NIMO weighs just 29 g — lighter than a pair of sunglasses. Carbon fiber frame + β-TITANIUM temples ensure all-day wear with no pressure marks or fatigue. Monochrome display further reduces eye strain for longer battery life.',
  vp_p3_highlight: 'Comfortable enough to forget it\'s there — until you need it.',
  vp_p3_stat: '29 g',
  vp_p3_stat_label: 'Total Weight',
  vp_bottom: 'Focus · Privacy · Comfort',

  // PillarDeepDive
  dd_label: 'In Depth',
  dd_title: 'A Deeper Look at Every Dimension',
  dd_1_label: 'Focus Filter',
  dd_1_title: 'Filter the Noise, Reclaim Your Focus',
  dd_1_quote: 'Every day your brain processes about 11 hours of digital information — emails, messages, notifications, pop-ups. NIMO filters the noise and surfaces only what truly deserves your attention.',
  dd_1_highlight: 'This isn\'t "use your phone less" — it\'s redefining focus.',
  dd_1_stat: 'HUD Display',
  dd_1_stat_desc: 'Never miss what matters',
  dd_2_label: 'Privacy Design',
  dd_2_title: 'Technology That Stays Invisible',
  dd_2_quote: 'Every NIMO innovation serves one goal: making smart glasses a truly all-day wearable that goes unnoticed and creates no burden.',
  dd_2_highlight: 'No social awkwardness. Use it anywhere.',
  dd_2_stat: '100%',
  dd_2_stat_desc: 'Camera-free design',
  dd_3_label: 'Comfort',
  dd_3_title: 'All-Day Wear, Zero Burden',
  dd_3_quote: 'We conducted wear tests with thousands of users to ensure the nose bridge and ears feel no pressure even after extended wear.',
  dd_3_highlight: 'Comfortable enough to forget it\'s there — until you need it.',
  dd_3_stat: '29g',
  dd_3_stat_desc: 'Ultra-light frame',

  // Testimonials
  test_label: 'Real Users',
  test_title: 'Real Scenarios · Really Works',
  test_subtitle: 'Reclaim your focus with NIMO',
  test_1_quote: 'Automatically records meeting conversations. AI extracts key points, action items, and decisions. Generate structured meeting notes with one tap afterward.',
  test_1_name: 'Li Ming',
  test_1_role: 'Product Manager',
  test_1_tag: 'AI Meeting Notes',
  test_2_quote: 'Import your script before a speech, presentation, or livestream. AI auto-tracks your progress and displays it in real time. Adjustable speed, pause/skip support. Speak confidently — no more blanking out.',
  test_2_name: 'Dr. Wang',
  test_2_role: 'Healthcare Professional',
  test_2_tag: 'Teleprompter',
  test_3_quote: 'No need to stop and check the route while cycling. Navigation cues appear gently at the edge of my vision — safe and focused. The most comfortable ride I\'ve ever had.',
  test_3_name: 'Liu Yang',
  test_3_role: 'Freelance Writer',
  test_3_tag: 'HUD Navigation',
  test_4_quote: 'Real-time translation in 10+ languages with under 2-second latency. They speak English, you see Chinese subtitles. You speak Chinese, they see English on their phone. No more stress in international meetings.',
  test_4_name: 'Chen Siyuan',
  test_4_role: 'Travel Blogger',
  test_4_tag: 'Global Travel',

  // Highlights
  hl_label: 'Core Technology',
  hl_title1: 'Technology',
  hl_title2: 'That Stays Invisible',
  hl_subtitle: 'Every innovation serves one goal — making NIMO an all-day wearable that goes unnoticed and creates no burden.',
  hl_f1_title: 'AI Smart Info Filtering',
  hl_f1_desc: 'Our proprietary NimoFilter™ engine intercepts distractions in real time, reducing unnecessary attention switches and helping users reclaim focus.',
  hl_f2_title: 'Holographic Waveguide Display',
  hl_f2_desc: '1500 nit brightness, readable in direct sunlight. Volume holographic grating waveguide technology delivers an outstanding visual experience.',
  hl_f3_title: 'Monochrome Display · All-Day Battery',
  hl_f3_desc: 'Lower power consumption with monochrome display — 8–10 hours of normal use, 72-hour standby, fast charging supported.',
  hl_f4_title: 'IP54 Sealed Protection',
  hl_f4_desc: 'Exclusive airtight assembly process. Handles daily sweat and light rain with ease. Multiple patents protecting the design.',
  hl_f5_title: '35 g Ultra-Light Design',
  hl_f5_desc: 'Topology-optimized frame. Titanium + carbon fiber + medical-grade silicone. Just 35 g for all-day comfortable wear.',
  hl_f6_title: 'On-Device AI · Privacy Safe',
  hl_f6_desc: 'Zero cameras. All AI runs locally — no data sent to the cloud. Compliant with HIPAA/GDPR requirements.',
  hl_cta_title: 'Ready to Reclaim Your Focus?',
  hl_cta_sub: 'Join the NIMO Early Access program and be among the first to experience it.',
  hl_cta_btn1: 'Book an In-Person Demo',
  hl_cta_btn2: 'Learn More',

  // FAQ
  faq_label: 'FAQ',
  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Everything you want to know about NIMO, answered here.',
  faq_contact: 'Still have questions?',
  faq_btn1: 'Contact Us',
  faq_btn2: 'Book a Demo',
  faq_q1: 'Why does NIMO have no camera?',
  faq_a1: 'This is a strategic choice, not a technical limitation. The camera-free design lets NIMO enter hospital ICUs, boardrooms, gyms, and any other setting without privacy concerns or suspicious looks. It also complies with strict regulations like HIPAA/GDPR — a key "access pass" for medical and B2B environments.',
  faq_q2: 'Does monochrome display affect the experience?',
  faq_a2: 'Quite the opposite — monochrome display has three advantages: longer battery life (no charging needed all day); reduced eye strain for extended reading; and purer information delivery without color distractions. Think of it like a Kindle e-ink screen — easy on the eyes because it does one thing exceptionally well.',
  faq_q3: 'How is NIMO different from regular smart glasses?',
  faq_a3: 'Regular smart glasses chase "more features." NIMO chases "fewer distractions." Our AI engine filters digital noise and surfaces only what truly needs your attention. The ultra-light 35 g design means you can wear it all day without burden. We subtract, not add.',
  faq_q4: 'Can I see the screen clearly in sunlight?',
  faq_a4: 'Absolutely. NIMO uses volume holographic waveguide technology with brightness up to 3500 nit — clear and readable even in direct sunlight. Most smart glasses require you to find shade outdoors.',
  faq_q5: 'Do I need prescription lenses?',
  faq_a5: 'NIMO supports custom prescription lenses (100–800 degrees). If you normally wear glasses, choose the prescription version. If your vision is fine or you wear contacts, the standard version works great.',
  faq_q6: 'How long does the battery last?',
  faq_a6: 'Normal use (checking info 50–80 times a day) gives 8–10 hours. Heavy users get about 6 hours. Charging takes 90 minutes with fast-charge support. Standby time reaches 72 hours.',
  faq_q7: 'Is it waterproof?',
  faq_a7: 'NIMO is rated IP54 — protected against daily sweat, light rain, and splashes. Not suitable for swimming or showering, and not recommended for full submersion.',
  faq_q8: 'Which phone systems are supported?',
  faq_a8: 'iOS 13 and above, Android 8.0 and above. Connects via Bluetooth 5.2 — pairing takes under a minute.',
  faq_q9: 'Is my data safe?',
  faq_a9: 'All data processing happens locally on the device — nothing is uploaded to the cloud. We hold ISO 27001 certification and have passed independent third-party privacy audits. Your information is entirely under your control.',
  faq_q10: 'Can I customize the information filter rules?',
  faq_a10: 'Absolutely. In the app you can set which apps\' notifications appear immediately, which contacts have the highest priority, and different filter strategies for work hours vs. rest time. The AI engine learns your habits and gradually optimizes the rules.',
  faq_q11: 'Will I feel dizzy after wearing it for a long time?',
  faq_a11: 'NIMO\'s display is carefully positioned in the lower field of vision so it never blocks your normal line of sight. Monochrome display reduces visual stimulation intensity, making long-term use less fatiguing. First-time users are advised to start with 2–3 hours a day and gradually increase.',
  faq_q12: 'Can I try it before buying?',
  faq_a12: 'Individual users can request a 7-day no-questions-asked return (product must remain intact). Enterprises and medical institutions can apply for a 30–60 day pilot program with free devices and technical support.',
  faq_q13: 'What is the warranty policy?',
  faq_a13: 'NIMO comes with a 1-year warranty covering hardware defects not caused by user damage. Free repair or replacement within the warranty period. Discounted repair service available after the warranty expires.',
  faq_q14: 'Is NIMO right for me?',
  faq_a14: 'If you\'re frequently interrupted by phone notifications, need to quickly check information during meetings, rounds, or workouts, value privacy, or want to reduce digital distractions and reclaim focus — NIMO is very likely right for you.',
  faq_q15: 'Is installment payment available?',
  faq_a15: 'Installment payment is available via major credit cards. Specific rates depend on your payment platform.',

  // Footer
  footer_tagline: 'Reclaim Focus, Enter Flow',
  footer_desc: 'Redefining how people connect with the world — making every moment of focus possible.',
  footer_nav: 'Navigation',
  footer_products: 'Products',
  footer_biz: 'Business',
  footer_contact: 'Contact',
  footer_biz_label: 'Brand & Media Partnerships',
  footer_nav_home: 'Home',
  footer_nav_brand: 'Brand Story',
  footer_product_nimo: 'NIMO Smart Glasses',
  footer_copyright: '© 2026 BitFantasy Inc. All rights reserved.',
  footer_icp: '粤ICP备2025446590号',
  footer_agreement: 'Terms of Service',
  footer_privacy: 'Privacy Policy',
  footer_ad_notice: 'All commercial promotions on this website that directly or indirectly market products or services to consumers constitute "advertising" (excluding product information such as packaging, specifications, and after-sales guarantees).',

  // Pre-order Form
  preorder_label: 'Early Access',
  preorder_title: 'Be the First to Experience NIMO',
  preorder_subtitle: 'Join our pre-order waitlist and get exclusive early-bird pricing, priority shipping, and insider updates before the official launch.',
  preorder_badge: 'Limited Early Access',
  preorder_name: 'Full Name',
  preorder_name_ph: 'Your full name',
  preorder_email: 'Email Address',
  preorder_email_ph: 'your@email.com',
  preorder_country: 'Country / Region',
  preorder_country_ph: 'e.g. United States',
  preorder_use_case: 'Primary Use Case',
  preorder_use_case_ph: 'Select your main use case',
  preorder_use_work: 'Work & Productivity',
  preorder_use_health: 'Healthcare & Medical',
  preorder_use_sport: 'Sports & Fitness',
  preorder_use_travel: 'Travel & Navigation',
  preorder_use_other: 'Other',
  preorder_lens: 'Do you need prescription lenses?',
  preorder_lens_yes: 'Yes',
  preorder_lens_no: 'No',
  preorder_message: 'Anything else you\'d like to share?',
  preorder_message_ph: 'Tell us about your use case, questions, or expectations... (max 500 characters)',
  preorder_submit: 'Join the Waitlist',
  preorder_submitting: 'Submitting...',
  preorder_success_title: 'You\'re on the list!',
  preorder_success_msg: 'Thank you for your interest in NIMO. We\'ll reach out with exclusive early-bird details soon.',
  preorder_perk1: 'Early-bird pricing',
  preorder_perk2: 'Priority shipping',
  preorder_perk3: 'Exclusive updates',
  preorder_perk4: 'Free trial option',

  // Dealer page
  dealer_hero_label: 'Partnership · Become a Dealer',
  dealer_hero_title: 'Build the Future with NIMO',
  dealer_hero_desc: 'We invite quality partners across the globe to join the NIMO dealer network — share in the rapid growth of the AI glasses market and co-create the next generation of human-computer interaction.',
  dealer_apply_label: 'Apply Now',
  dealer_apply_title: 'Apply to Become\na NIMO Dealer',
  dealer_apply_desc: 'Fill out the application form and our business team will contact you within 3–5 business days to answer your questions and move the partnership forward.',
  dealer_contact_phone: 'Phone',
  dealer_contact_email: 'Business Email',
  dealer_contact_time: 'Response Time',
  dealer_contact_time_val: '3–5 Business Days',
  dealer_form_name: 'Contact Name',
  dealer_form_name_ph: 'Your full name',
  dealer_form_phone: 'Phone Number',
  dealer_form_phone_ph: 'Your phone number',
  dealer_form_email: 'Email Address',
  dealer_form_email_ph: 'your@email.com',
  dealer_form_company: 'Company / Store Name',
  dealer_form_company_ph: 'Your company or store name',
  dealer_form_city: 'City',
  dealer_form_city_ph: 'e.g. New York, London',
  dealer_form_tier: 'Intended Tier',
  dealer_form_tier_ph: 'Select a tier',
  dealer_form_tier_silver: 'Silver Dealer (≥50 units)',
  dealer_form_tier_gold: 'Gold Dealer (≥200 units)',
  dealer_form_tier_diamond: 'Diamond Dealer (≥500 units)',
  dealer_form_error: 'Submission failed. Please try again or email partner@nimofantasy.ai',
  dealer_form_submit: 'Submit Application',
  dealer_form_submitting: 'Submitting...',
  dealer_form_privacy: 'By submitting, you agree to NIMO collecting and processing the above information solely for dealer qualification evaluation.',
  dealer_success_title: 'Application Submitted',
  dealer_success_desc: 'Thank you for your interest! Our business team will reach out to you shortly. Please keep your phone available.',
  dealer_success_reset: 'Submit Another',
};

export default common;
